import React from "react";

export default function StatsPanel({ stats, winRate }) {
  return (
    <section className="glass-card section-card">
      <div className="section-header">
        <h2>Din statistik</h2>
      </div>

      <div className="stats-grid">
        <div className="stat-box">
          <span>Spelade</span>
          <strong>{stats.played}</strong>
        </div>

        <div className="stat-box">
          <span>Vinstprocent</span>
          <strong>{winRate}%</strong>
        </div>

        <div className="stat-box">
          <span>Streak</span>
          <strong>{stats.streak}</strong>
        </div>

        <div className="stat-box">
          <span>Bästa runda</span>
          <strong>{stats.best == null ? "–" : stats.best}</strong>
        </div>
      </div>
    </section>
  );
}
